import classNames from 'classnames';
import type { ReactNode } from 'react';
import s from './EmptyState.module.scss';

type EmptyStateVariant = 'transparent' | 'background' | 'default' | 'full';
type EmptyStateSize = 'sm' | 'lg';

export interface IEmptyStateProps {
  icon?: ReactNode;
  title: string;
  subtitle?: ReactNode;
  action?: ReactNode;
  variant?: EmptyStateVariant;
  size?: EmptyStateSize;
  className?: string;
  children?: ReactNode;
}

export const EmptyState = ({
  icon,
  title,
  subtitle,
  action,
  variant = 'background',
  size = 'sm',
  className,
  children,
}: IEmptyStateProps) => {
  'use memo';

  return (
    <div className={classNames(s.root, s[variant], s[size], className)}>
      <div className={s.group}>
        {icon && <div className={s.icon}>{icon}</div>}
        <div className={s.copy}>
          <p className={s.title}>{title}</p>
          {subtitle && <p className={s.subtitle}>{subtitle}</p>}
        </div>
      </div>
      {action && <div className={s.action}>{action}</div>}
      {children}
    </div>
  );
};
